/*
 * @Author: YuanYuan
 * @Date: 2024-02-23 11:41:13
 * @LastEditTime: 2024-07-25 10:47:46
 * @description: 通用的echarts options样式配置
 */
export const RectLegendStyle = {
  icon: 'rect',
  itemWidth: 8,
  itemHeight: 8,
  textStyle: {
    color: '#595959',
    lineHeight: 21
  }
}

export const GridStyle = {
  show: true,
  borderWidth: 0.5,
  borderColor: '#E5E5E5'
}

export const TooltipStyle = {
  backgroundColor: '#FFFFFF',
  extraCssText: 'box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.15)',
  confine: true,
  padding: 16,
  textStyle: {
    color: 'rgba(0,0,0,0.85)'
  },
  axisPointer: { // 鼠标悬浮指示线
    type: 'cross',
    label: {
      color: 'rgba(0,0,0,0.65)',
      backgroundColor: '#fff'
    },
    crossStyle: {
      type: 'dashed'
    },
    lineStyle: {
      color: '#FFAC34',
      type: 'solid'
    }
  }
}

export const RectMaker = color => `<span style="margin-right:6px; background:${color};display: inline-block;height:8px;width:8px" class="legend-rect"></span>`

export const XAxisCategoryStyle = {
  boundaryGap: 0, // 坐标轴两边不留白
  axisLine: { show: false },
  axisTick: { show: false },
  axisLabel: { color: 'rgba(0, 0, 0, 0.5)' },
  splitLine: { show: false },
  position: 'bottom',
  offset: 3
}

export const YAxisValueStyle = {
  show: true,
  axisLine: { show: false },
  axisTick: { show: false },
  axisLabel: {
    color: 'rgba(0, 0, 0, 0.5)'
  },
  splitLine: {
    show: true,
    lineStyle: {
      type: 'solid',
      color: '#E5E5E5',
      width: 0.5
    }
  }
}

export const ChartColors = [
  "#2d74ff",
  "#47cbff",
  "#ff7a33",
  "#45de7f",
  "#ffac34",
  "#5ad7d8",
  "#8163e9",
  "#ff5f45",
  "#01c581",
  "#b754f6",
  "#fcda0f",
  "#9b501b",
  "#2998ff",
  "#938bf8",
  "#ffc318",
  "#f270c7",
  "#49c0a3",
  "#ff848d",
  "#8e4abb"
]
